<div class="flex gap-1 items-center">
  <span class="text-proffeo-muted text-sm">{{ 'task-details-modal-changed-status' | translate }}: {{ label() }}</span>
</div>
